const transform = list => list.map((item, index) => ({ value: item, label: item }))

// State
const state = {
  isLoading: false,
  data: {
    nonSystem: transform([
      'A⁺⁺⁺ → D',
      'A⁺⁺ → G',
      'A → G',
      'A⁺ → F',
      'A⁺ → G'
    ]),
    system: transform([
      'A⁺⁺⁺ → G'
    ])
  }
}

export default {
  state
}



// WEBPACK FOOTER //
// ./src/store/modules/arrowSpectrums.js